export const componentsData =  
{
    "categories": [
      {
        "name": "Headings",
        "components": [
          { "name": "Heading 1", "markdown": "# Heading 1" },
          { "name": "Heading 2", "markdown": "## Heading 2" },
          { "name": "Heading 3", "markdown": "### Heading 3" }
        ]
      },
      {
        "name": "Text Formatting",
        "components": [
          { "name": "Bold Text", "markdown": "**Bold Text**" },
          { "name": "Italic Text", "markdown": "*Italic Text*" },
          { "name": "Blockquote", "markdown": "> Blockquote" }
        ]
      },
      {
        "name": "Code & Block",
        "components": [
          { "name": "Code Block", "markdown": "``` \n// Your code here\n```" },
          { "name": "Horizontal Rule", "markdown": "---" }
        ]
      }
    ]
  }
  